export class UserCourseTemplateRating {
  courseTemplateId: number;
  rating: number;
}
